import { DataCourse } from '../../../shared/interfaces/course.interface';
import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ActivatedRoute, Router, RouterModule } from '@angular/router';
import { CoursesService } from 'src/app/services/courses.service';
import { Subject, Subscription, map, switchMap, takeUntil } from 'rxjs';
import { CertificatesService } from 'src/app/services/certificates.service';
import { FechaEsPipe } from "../../../shared/interfaces/fecha-es.pipe";
import { LessonsService } from 'src/app/services/lessons.service';

@Component({
  selector: 'app-course-card',
  standalone: true,
  templateUrl: './course-card.component.html',
  styleUrls: ['./course-card.component.scss'],
  imports: [CommonModule, RouterModule, FechaEsPipe]
})
export class CourseCardComponent {
  option: string = 'Todos los cursos';
  user: any;
  hasCourses: boolean = true;
  allCourses: DataCourse[] = [];
  coursesToShow: DataCourse[] = [];
  updatePercent: Subscription;
  loadingCourseId: string | null = null;
  private destroy$ = new Subject<void>();

  constructor(
    public coursesService: CoursesService,
    private route: ActivatedRoute,
    private router: Router,
    private certificatesService: CertificatesService,
    private lessonsService: LessonsService
  ) {
    this.updatePercent = this.lessonsService.onUpdateLocalLessonLoadPercent$.subscribe({
      next: $event => {
        this.updatePercentInMenu($event);
      },
      error: error => console.error('Error actualizando el porcentaje', error)
    })
  }

  onCourseClick(course: DataCourse): void {
    if (this.loadingCourseId) return;
    this.loadingCourseId = course.id;
    this.router.navigate(['/cursos' + course.attributes.path.alias]);
  }

  ngOnInit(): void {
    this.route.queryParams.pipe(
      takeUntil(this.destroy$),
      switchMap(params => {
        const categorySearch = params['category'];
        if (categorySearch) {
          return this.coursesService.courses$.pipe(
            map(courses => this.filterCoursesByCategoryValue(courses, categorySearch))
          );
        } else {
          return this.coursesService.courses$;
        }
      }),
      map(courses => this.associateCertificatesToCourses(courses)),
    ).subscribe(
      {
        next: courses => {
          this.coursesToShow = courses;
          this.allCourses = courses;
        },
        error: error => {
          console.log(error);
        }
      }
    );

    this.coursesService.hasCourses$.pipe(takeUntil(this.destroy$)).subscribe(
      {
        next: has => {
          this.hasCourses = has;
        },
        error: error => {
          console.log(error);
        }
      }
    );
  }

  filterCoursesByCategory(category: string) {
    this.coursesService.courses$.pipe(
      takeUntil(this.destroy$),
      map(courses => this.filterCoursesByCategoryValue(courses, category)),
      map(courses => this.associateCertificatesToCourses(courses)),
    ).subscribe(
      {
        next: filteredCourses => {
          this.allCourses = filteredCourses;
          this.coursesToShow = filteredCourses;
        },
        error: error => {
          console.error('Error trayendo los cursos por categoría', error)
        }
      }
    );
  }

  private filterCoursesByCategoryValue(courses: any[], category: string): any[] {
    return courses.filter(course =>
      course.categories.some((cat: any) =>
        cat.attributes.name.toLowerCase() === category.toLowerCase()
      )
    );
  }

  private associateCertificatesToCourses(courses: DataCourse[]) {
    courses.forEach(course => {
      const certificate = this.certificatesService.certificates.find((certificate: any) => certificate.courseId === course.attributes.drupal_internal__nid);
      if (certificate) {
        course.certificate = certificate;
      }
    });
    return courses;
  }

  //Validar si en esto es así o no
  isCompleted(course: DataCourse): boolean {
    return course.progress === 100 || !!course.certificate;
  }

  onClick(opt: string) {
    this.option = opt;
    this.filterCourses(opt);
  }

  //Validar si es así o no
  filterCourses(option: string): void {
    switch (option) {
      case 'En proceso':
        this.coursesToShow = this.allCourses.filter(course => course.progress < 100);
        break;
      case 'Finalizados':
        this.coursesToShow = this.allCourses.filter(course => course.progress === 100);
        break;
      default:
        this.coursesToShow = [...this.allCourses];
        break;
    }
  }

  updatePercentInMenu(e: any) {
    this.coursesToShow.forEach((course: any) => {
      if (course.id === e.course?.id) {
        course.progress = e.percentage;
      }
    })
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
